import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Users, Sparkles, HandHeart } from 'lucide-react';
export function SocialImpactSection() {
  return <section className="py-20 bg-gradient-to-b from-white to-blue-50" dir="rtl" data-id="element-229">
      <div className="container mx-auto px-4" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-231">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-232">
            מעבר לספורט - השפעה חברתית
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-233">
            המועדון שלנו נולד מרצון לתרום ולעזור, והוא ממשיך להוות מרחב של נתינה
            וקהילה
          </p>
        </motion.div>

        {/* Main Story Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-12 border border-blue-100" data-id="element-234">
          <div className="flex items-start gap-6 mb-6" data-id="element-235">
            <div className="bg-gradient-to-br from-blue-500 to-cyan-500 p-4 rounded-2xl shadow-lg" data-id="element-236">
              <Heart className="w-8 h-8 text-white" data-id="element-237" />
            </div>
            <div data-id="element-238">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-239">
                מהתנדבות למפונים למועדון קהילתי
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-240">
                פעילות המועדון התחילה מפעילות התנדבותית למפונים שהגיעו לאזור
                הכנרת במלחמה מהצפון והדרום. מתוך רצון לתת מרחב של שקט, ריפוי
                וחיבור לטבע, פתחנו את המועדון לכל מי שזקוק לרגע של נשימה.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Impact Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-241">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-blue-50 hover:shadow-xl transition-shadow" data-id="element-242">
            <div className="bg-gradient-to-br from-purple-100 to-pink-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6" data-id="element-243">
              <Users className="w-8 h-8 text-purple-600" data-id="element-244" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-245">
              אירוח קבוצות וגופים
            </h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-246">
              המועדון מארח ותורם באגודות וגופים שונים - חיילים, ילדים, קבוצות
              פוסט-טראומה ועוד. אנחנו מאמינים בכוח המרפא של המים.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-blue-50 hover:shadow-xl transition-shadow" data-id="element-247">
            <div className="bg-gradient-to-br from-green-100 to-emerald-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6" data-id="element-248">
              <HandHeart className="w-8 h-8 text-green-600" data-id="element-249" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-250">
              תרומה לעמותות חברתיות
            </h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-251">
              כל הרווחים מהמועדון נתרמים לעמותות חברתיות. כל חתירה, כל שיעור, כל
              חבר - תורמים למעגל של נתינה וחיבור קהילתי.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-blue-50 hover:shadow-xl transition-shadow" data-id="element-252">
            <div className="bg-gradient-to-br from-yellow-100 to-orange-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6" data-id="element-253">
              <Sparkles className="w-8 h-8 text-orange-600" data-id="element-254" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-255">
              קהילה שנותנת
            </h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-256">
              חברי המועדון הם חלק ממשהו גדול יותר - קהילה שמאמינה בערך של נתינה,
              תמיכה הדדית וחיבור אמיתי בין אנשים.
            </p>
          </motion.div>
        </div>

        {/* Bottom Quote */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center mt-16" data-id="element-257">
          <p className="text-2xl md:text-3xl font-light text-[#0A5F8F] italic max-w-3xl mx-auto" data-id="element-258">
            "כשאתם חותרים איתנו, אתם לא רק משפרים את עצמכם - אתם גם עוזרים
            לאחרים"
          </p>
        </motion.div>
      </div>
    </section>;
}